import React from 'react'

import { easasAlert } from 'components/fragments/easas-global-fragment/EasasGlobalAlerts'
import { MdmObjectDto, useGetObjectQuery, useUpdateObjectMutation } from 'gql/generated/types'
import { ProgressSpinner } from 'primereact/progressspinner'
import { useNavigate, useParams } from 'react-router-dom'
import ObjectForm from '../components/ObjectForm'
import ErrorPage from './ErrorPage'

const EditObjectForm = () => {
  const { projectId, objectId } = useParams();
  const navigate = useNavigate()
  const { data, error, loading } = useGetObjectQuery({ variables: { id: objectId! } });
  const [updateObjectMutation] = useUpdateObjectMutation({
    onCompleted: () => {
      easasAlert({
        severity: "success",
        summary: "Success",
        detail: "Object updated successfully",
        life: 3000,
      });
      navigate(`/mdm/${projectId}/`);
    },
    onError: err => {
      easasAlert({ severity: "error", summary: "Error", detail: err.message, life: 3000 });
    },
  });
  
  if (error) {
    return <ErrorPage msg={`Object not found by id: ${objectId}`} />;
  }

  if (loading) return <ProgressSpinner className='mt-3 w-full' />

  const handleUpdate = (object: MdmObjectDto) => {
    const { deviceRelations, boundDatasets, address, ...restObject } = object;
    if (!address) {
      updateObjectMutation({ variables: { object: restObject } });
    } else {
      const { fullAddress, ...restAddress } = address!;
      updateObjectMutation({ variables: { object: { ...restObject, address: restAddress } } });
    }

  }

  return <ObjectForm object={data?.mdmObjectById as MdmObjectDto} onSubmit={handleUpdate} />
}

export default EditObjectForm